import { render, staticRenderFns } from "./my-statement.vue?vue&type=template&id=fc63e7be"
import script from "./my-statement.vue?vue&type=script&lang=js"
export * from "./my-statement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports